module.exports = __webpack_public_path__ + "img/15.0a7dd22.svg";